// 管理员路由守卫
import { isAdminLoggedIn, hasAdminPermission, clearAdminData } from './adminAuth';
import { Message } from 'element-ui';

// 管理员权限配置
const ADMIN_PERMISSIONS = {
  'FileManagement': 'canFileManage',
  'CategoryManagement': 'canFileManage', // 分类管理需要文件管理权限
  'BannerManagement': 'canFileManage', // 轮播图管理需要文件管理权限
  'UserManagement': 'canUserManage', 
  'SystemManagement': 'canSystemManage'
};

// 管理员路由守卫
export function adminRouteGuard(to, from, next) {
  // 检查是否为管理员路由
  const isAdminRoute = to.matched.some(record => record.meta.requiresAdmin);
  
  if (!isAdminRoute) {
    // 非管理员路由，直接通过
    next();
    return;
  }

  // 检查管理员登录状态
  if (!isAdminLoggedIn()) {
    Message.warning('请先登录管理员账号');
    next({ name: 'AdminLogin' });
    return;
  }

  // 检查特定权限
  const requiredPermission = to.meta.requiredPermission;
  if (requiredPermission && !hasAdminPermission(requiredPermission)) {
    Message.error('权限不足，无法访问此页面');
    next({ name: 'FileManagement' }); // 跳转到有权限的页面
    return;
  }

  // 检查权限级别
  const requiredLevel = to.meta.requiredLevel;
  if (requiredLevel && !hasAdminPermissionLevel(requiredLevel)) {
    Message.error('权限级别不足，无法访问此页面');
    next({ name: 'FileManagement' });
    return;
  }

  next();
}

// 管理员登录状态检查
export function checkAdminAuth() {
  if (!isAdminLoggedIn()) {
    Message.warning('管理员登录已过期，请重新登录');
    clearAdminData();
    return false;
  }
  return true;
}

// 权限检查装饰器
export function requireAdminPermission(permission) {
  return function(target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    
    descriptor.value = function(...args) {
      if (!hasAdminPermission(permission)) {
        Message.error(`需要${permission}权限才能执行此操作`);
        return;
      }
      return originalMethod.apply(this, args);
    };
    
    return descriptor;
  };
}

// 权限级别检查装饰器
export function requireAdminLevel(level) {
  return function(target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    
    descriptor.value = function(...args) {
      if (!hasAdminPermissionLevel(level)) {
        Message.error(`需要权限级别${level}才能执行此操作`);
        return;
      }
      return originalMethod.apply(this, args);
    };
    
    return descriptor;
  };
}

export default {
  adminRouteGuard,
  checkAdminAuth,
  requireAdminPermission,
  requireAdminLevel
};
